module.exports = __webpack_public_path__ + "img/postscript.14273323.svg";